import React, { PureComponent } from 'react';
import toHTML from 'vdom-to-html';
import isEqual from 'lodash.isequal';

import parliamentSVG from '../../vendor/parliament-svg';


function getParliamentAsHTML(data) {
  const svgVDom = parliamentSVG(data, false);
  return toHTML(svgVDom);
}


class ParliamentVis extends PureComponent {
  state = {
    svg: null
  }

  componentDidMount() {
    this.updateSvg();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!isEqual(this.props.data, prevProps.data)) {
      this.updateSvg();
    }
  }

  updateSvg() {
    this.setState({
      svg: getParliamentAsHTML(this.props.data)
    });
  }

  render() {
    return (
      <div className="parliament__viscontainter" dangerouslySetInnerHTML={{ __html: this.state.svg }} />
    );
  }
}

export default ParliamentVis;
